/* istanbul ignore file */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { App, KhFile } from '../../models';

@Injectable({
    providedIn: 'root'
})
export class UploadDataService extends HttpBaseService {

    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient
    ) {
        super(_httpClient);
    }

    uploadFile(app: App, file: FormData): Observable<any> {
        const url = `${this.route}${app.id}/containers/${app['fileContainers'].private.name}/uploads/file`;
        return this.httpPost(url, file);
    }

    removeFile(app: App, file: KhFile): Observable<any> {
        const url = `${this.route}${app.id}/uploads/deleted-file`;
        return this.httpPost(url, file);
    }

    uploadUserGuide(file: FormData): Observable<any> {
        const url = `${this.route}uploads/user-guides`;
        return this.httpPost(url, file);
    }
}
